<div [formGroup]="deviceForm" fxLayout="column" fxLayoutGap="15px">
  <div *ngIf="this.deviceObject" fxLayout="row" fxLayoutGap="15px" class="button-container">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!deviceForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button tabindex="-1"  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <mat-card>
    <h3>Dane</h3>

    <div fxLayout="column" fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px">
        <app-dynamic-dict fxFlex="100" label="Rodzaj"
                          [required]="true" [control]="typeOfDeviceControl"
                          [dictType]="DYNAMIC_DICTIONARY_DEVICE_TYPE">
        </app-dynamic-dict>


        <mat-form-field fxFlex="50">
          <mat-label>Nazwa</mat-label>
          <input type="text" matInput [formControl]="nameControl">
          <mat-error *ngIf="nameControl.hasError('required')">To pole jest wymagane</mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <mat-form-field fxFlex="50">
          <mat-label>Numer seryjny</mat-label>
          <input type="text" matInput
                 [formControl]="serialNumberControl"
                 [value]="serialNumberControl.value | uppercase">
          <mat-error *ngIf="serialNumberControl.hasError('required')">To pole jest wymagane</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="50">
          <mat-label>Numer wewnętrzny</mat-label>
          <input type="text" matInput [formControl]="extensionNumberControl">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <mat-form-field fxFlex="50">
          <mat-label>Notatka</mat-label>
          <input type="text" matInput [formControl]="noteControl">
        </mat-form-field>

        <app-dict-users fxFlex="50" label="Użytkownik"
                        [required]="true"
                        [control]="userControl"
                        [multiple]="false"
                        [filterEmployeeOnly]="true"
                        [filterActiveOnly]="true">
        </app-dict-users>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="50">
          <mat-slide-toggle [formControl]="diskEncryptionControl">Szyfrowanie dysku</mat-slide-toggle>
        </div>
        <div  fxFlex="50">
          <mat-slide-toggle [formControl]="requirePasswordChangeControl">Wymuszenie zmiany hasła systemowego</mat-slide-toggle>
        </div>
      </div>

    </div>

  </mat-card>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            [disabled]="!deviceForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button tabindex="-1"  (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

</div>
